import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToArray',
  standalone: false,
})
export class EnumToArrayPipe implements PipeTransform {
  transform(inputEnum): any {
    return Object.keys(inputEnum)
      .map((k) => ({ key: k, value: inputEnum[k as any] }))
      .sort((a, b) => (a.value < b.value ? -1 : 1));
  }
}
